import { ActionTypes } from "../actions";
const BuilderEditMode = {
  BUILD: "build",
  CONTENT: "content",
  INTERACT: "interact"
};
function getInitialState() {
  return null;
}
function reducer(state = getInitialState(), action) {
  switch (action.type) {
    case ActionTypes.SET_BUILDER_EDIT_MODE:
      return action.payload.editMode;
    default:
      return state;
  }
}
export {
  BuilderEditMode,
  getInitialState,
  reducer
};
//# sourceMappingURL=builder-edit-mode.js.map